import router from '../router'
export const adminAuthGuard = (to, from, next) => {
    let userData = localStorage.getItem('cbs_admin_usertoken')
    if(userData){
        return next()
    } else {
        router.push({ name: 'AdminLogin' })
    }
}


// WEBPACK FOOTER //
// ./src/auth/adminAuthGuard.js